import { Form, Input, Typography } from 'antd'
import { t } from 'i18next'
import { memo } from 'react'
import styled from 'styled-components'

const Section = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 8px;
`

const FlowCytometryReviewAnalysisConfigurationModalDataStep = memo(() => {
  return (
    <>
      <Section>
        <Typography.Text strong>
          {t('reviewAnalysisConfigurationModal.sections.experimentId.title')}
        </Typography.Text>
        <Form.Item
          name="experimentId"
          label={t('reviewAnalysisConfigurationModal.fields.experimentId.label')}
          rules={[
            {
              required: true,
              whitespace: true,
              message: t('reviewAnalysisConfigurationModal.validation.required'),
            },
          ]}
          extra={t('reviewAnalysisConfigurationModal.fields.experimentId.helperText')}
        >
          <Input
            placeholder={t(
              'reviewAnalysisConfigurationModal.fields.experimentId.placeholder'
            )}
          />
        </Form.Item>
      </Section>

      <Section>
        <Typography.Text strong>
          {t('reviewAnalysisConfigurationModal.sections.ssrExperimentId.title')}
        </Typography.Text>
        <Form.Item
          name="ssrExperimentId"
          label={t('reviewAnalysisConfigurationModal.fields.ssrExperimentId.label')}
          rules={[
            {
              required: true,
              whitespace: true,
              message: t('reviewAnalysisConfigurationModal.validation.required'),
            },
          ]}
          extra={t('reviewAnalysisConfigurationModal.fields.ssrExperimentId.helperText')}
        >
          <Input
            placeholder={t(
              'reviewAnalysisConfigurationModal.fields.ssrExperimentId.placeholder'
            )}
          />
        </Form.Item>
      </Section>

      <Section>
        <Typography.Text strong>
          {t(
            'reviewAnalysisConfigurationModal.sections.additionalExperimentIds.title'
          )}
        </Typography.Text>
        <Form.Item
          name="additionalExperimentIds"
          label={t(
            'reviewAnalysisConfigurationModal.fields.additionalExperimentIds.label'
          )}
          extra={t(
            'reviewAnalysisConfigurationModal.fields.additionalExperimentIds.helperText'
          )}
        >
          <Input
            placeholder={t(
              'reviewAnalysisConfigurationModal.fields.additionalExperimentIds.placeholder'
            )}
          />
        </Form.Item>
        <Form.Item
          name="apiToken"
          label={t(
            'reviewAnalysisConfigurationModal.fields.apiToken.label'
          )}
          rules={[
            {
              required: true,
              whitespace: true,
              message: t('reviewAnalysisConfigurationModal.validation.required'),
            },
          ]}
        >
          <Input
            placeholder={t(
              'reviewAnalysisConfigurationModal.fields.apiToken.placeholder'
            )}
          />
        </Form.Item>
      </Section>
    </>
  )
})

export default FlowCytometryReviewAnalysisConfigurationModalDataStep

